import { useContext } from "react";
import { LocalePreferenceContext } from "@/providers/locale-preference-provider";

export const useLocalePreference = () => useContext(LocalePreferenceContext);

export default useLocalePreference;
